import apiCall from './apiCall';

const getAllPrivileges = async (param: any) => {
    const query = `?search=${param.search || ''}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/Privilege/GetAllPrivileges${query}`;
    return apiCall('get', URL);
};

const getPrivilegeById = async (id: string) => {
    const URL = `/Privilege/GetPrivilegeById/${id}`;
    return apiCall('get', URL);
};

const postPrivilege = async (data: any) => {
    const URL = '/Privilege/Create';
    return apiCall('post', URL, data);
};

const putPrivilege = async (data: any) => {
    const URL = '/Privilege/Update';
    return apiCall('post', URL, data);
};

const deletePrivilege = async (data: any) => {
    const URL = '/Privilege/Delete';
    return apiCall('post', URL, data);
};

const getAllRefDataPrivileges = async () => {
    const URL = '/Privilege/GetAllRefDataPrivileges';
    return apiCall('get', URL);
};

export {
    getAllPrivileges,
    getPrivilegeById,
    postPrivilege,
    putPrivilege,
    deletePrivilege,
    getAllRefDataPrivileges,
};
